import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  tokenExpiry: null,
  isAuthenticated: false,
  loading: false,
  error: null
};

const myexamyaiSlice = createSlice({
  name: "myexamyai",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.token = action.payload.token;
      state.tokenExpiry = Date.now() + (24 * 60 * 60 * 1000);
      state.isAuthenticated = true;
      state.error = null;
    },
    clearAuth: (state) => {
      state.token = null;
      state.tokenExpiry = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export const { setAuth, clearAuth, setLoading, setError } = myexamyaiSlice.actions;
export default myexamyaiSlice.reducer;